<div class="wrapper page-option-v1">
  <app-nav-bar></app-nav-bar>
  <app-loading-page></app-loading-page>
  <ng-progress></ng-progress>

  <router-outlet></router-outlet>
  <app-scroll-top></app-scroll-top>
  <app-footer></app-footer>
</div>